<template>
    <div class="row">
        <div class="col-6 mx-auto">
            <remote-newsroom-item
                :id="newsroomItemId"
            >
                <template v-slot:default="{newsroomItem: initialNewsroomItem}">
                    <newsroom-item-editor-wrapper
                            :title="resource('Newsroom_Edit_Header')"
                            
                            :newsroom-item="initialNewsroomItem"
                    >
                        <template v-slot:action-buttons="{ isValid, newsroomItem }">
                            <button :class="{ 'disabled': !isValid }"
                                    class="btn btn-primary navbar-btn"

                                    @click="submit(isValid, newsroomItem)"
                            >{{resource('Newsroom_Edit_Submit_Btn')}}</button>


                            <button v-if="canDelete"
                                    class="btn btn-danger navbar-btn delete-news"

                                    @click="deleteItem()"
                            >{{resource('Newsroom_Delete_Submit_Btn')}}</button>
                        </template>
                    </newsroom-item-editor-wrapper>
                </template>
            </remote-newsroom-item>
        </div>
    </div>
</template>

<script>
    import api from './../api';
    import { bootstrapDangerGrowl as errorGrowl, bootstrapSuccessGrowl as successGrowl } from "../../../Util/growler";
    import loader from '../../../Util/loader';
    import {promptV2 as prompt} from "../../../Util/prompt";

    import resourceMixin from "../../../Util/Mixins/resources";
    import permissionMixin from "../Mixins/permissions";

    import NewsroomItemEditorWrapper from "./Editor/NewsroomItemEditorWrapper.vue";
    import RemoteNewsroomItem from "./Remote/RemoteNewsroomItem.vue";

    export default {
        name: 'newsroom-edit',
        components: {
            RemoteNewsroomItem,
            NewsroomItemEditorWrapper
        },
        mixins: [permissionMixin, resourceMixin],
        methods: {
            submit(isValid, newsroomItem){
                if(!isValid) return;

                const vm = this;

                loader.show();

                api.editNewsroomItem(newsroomItem).then(() => {
                    loader.hide();

                    successGrowl(vm.resource('Newsroom_Edit_Success_Message'));
                    vm.$router.push('/Newsroom');
                },
                err => {
                    loader.hide();
                    errorGrowl(err)
                });
            },
            deleteItem(){
                const vm = this;

                prompt(undefined, vm.resource('Newsroom_Delete_ConfirmationText'))
                    .then(
                        () => {
                            loader.show();

                            api.deleteNewsroomItem(vm.newsroomItemId).then(() => {
                                loader.hide();

                                successGrowl(vm.resource('Newsroom_Delete_Success_Message'));
                                vm.$router.push('/Newsroom');
                            },
                            err => {
                                loader.hide();
                                errorGrowl(err)
                            });      
                        },
                        () => {}
                    );
            }
        },
        computed: {
            newsroomItemId(){
                return this.$route.params.id;
            }
        }
    }
</script>